import { createSelector } from 'reselect';
import get from 'lodash/get';

import servingInstructions from 'constants/servingInstructions';

import { getProductById } from 'redux/modules/entities/selectors/products';

export const getProductContents = createSelector([getProductById], product =>
  get(product, 'contents', null),
);

export const getProductCookingStatus = createSelector([getProductContents], contents =>
  get(contents, 'cookingStatus', null),
);
